$(function(){
  //Simon: Note: These images are in a slider, maybe switch them on click within the slider?

  // console.clear();//
  // $(document.querySelector('.vehicleGraphicOn_h') ||
  //     document.querySelector('.vehicleGraphicOn_v')).on('click', function(){
  //   this.classList.remove(this.dataset.effectClass);
  //   void this.offsetWidth;
  //   this.classList.add(this.dataset.effectClass);
  //
  //   let imageElement = this.firstElementChild;
  //
  //   if(imageElement.getAttribute('src') === imageElement.getAttribute('data-alt-image')) {
  //     imageElement.setAttribute('src', imageElement.getAttribute('data-orig-image'));
  //     imageElement.nextElementSibling.innerHTML = this.dataset.text
  //   } else {
  //     imageElement.setAttribute('src', imageElement.getAttribute('data-alt-image'));
  //     imageElement.nextElementSibling.innerHTML = this.dataset.altText
  //   }
  // }); //$(productImage).on('click', function(){ END

  document.querySelectorAll('.designBox').forEach(function(item) {
    $(item).on('click', function() {
      let designImgElement = this.querySelector('img'),
          designSwitch = this.querySelector('.designSwitch'),
          effect = this.dataset.effectClass;
      this.classList.remove(effect);
      void this.offsetWidth;
      this.classList.add(effect);

      if(designSwitch.checked===true){
        designSwitch.checked=false;
        this.querySelector('img').setAttribute('src', $(designImgElement).data('alt-image'));
        this.querySelector('.designBoxTitle').innerHTML = this.dataset.text;
      } else {
        designSwitch.checked=true;
        this.querySelector('img').setAttribute('src', $(designImgElement).data('orig-image'));
        this.querySelector('.designBoxTitle').innerHTML = this.dataset.altText;
      }//if(designSwitch.checked===true){ END
    })//$(item).on('click', function() { END
  })//designSwitches.forEach(function(item) { END
}); //$(function(){ END